import { useDispatch } from 'react-redux';
import '../../css/base.css';
import { setActivity } from '../../store/AppSlice';

const WalkBrae = () => {

  const dispatch = useDispatch();

  const navigateToActivity = () => {
    dispatch(setActivity("BRAE"));
  }

  return (
    <div>
      <h2 className="walks-link-heading"><a  onClick={navigateToActivity}>The Brae</a></h2>
      <p className="walk-text">My favourite walk with the dog.  Beautiful view over the bay at Arnisdale and across to Knoydart in one direction and the small isles
                                    of Rarsaidh towards the Cuillin of Skye in the other.  

      </p>                                        
    </div>
  );
}

export default WalkBrae
